import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { aboutSchema } from '@/lib/seo';
import AboutHero from './components/AboutHero';
import Story from './components/Story';
import Timeline from './components/Timeline';
import Philosophy from './components/Philosophy';
import SystemBehind from './components/SystemBehind';
import TeamSection from './components/TeamSection';
import WhoBestWith from './components/WhoBestWith';
import ResultsBridge from './components/ResultsBridge';
import BrandStatement from './components/BrandStatement';
import WaysToWork from './components/WaysToWork';
import FinalCta from './components/FinalCta';
import Seo from '@/components/Seo';

export default function About() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Seo
        title="About Josh Hastings | Home Service Growth Strategist"
        description="Learn about Josh Hastings, a home service growth strategist helping established roofing, HVAC, hardscape and landscape businesses build measurable marketing systems and predictable growth."
        canonical="https://joshuawhastings.com/about"
      />

      <JsonLd data={aboutSchema} />

      <Header />

      <main>
        <AboutHero />
        <Story />
        <Timeline />
        <Philosophy />
        <SystemBehind />
        <TeamSection />
        <WhoBestWith />
        <ResultsBridge />
        <BrandStatement />
        <WaysToWork />
        <FinalCta />
      </main>

      <Footer />
    </div>
  );
}
